module.exports = __webpack_public_path__ + "img/award3.e78bf1ef.svg";